import { useState } from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";


// HelpCenter page components
import FaqCollapse from "pages/AcademiaCiber/icemba/components/FaqCollapse";
import Card from "@mui/material/Card";


function MBAStructure() {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabType = (event, newValue) => setActiveTab(newValue);
  const [collapse, setCollapse] = useState(false);

  return (
    <MKBox>
      {/* === Dark Section with Tabs === */}
      <MKBox component="section" variant="gradient" bgColor="dark" py={{ xs: 0, lg: 2 }}>
        <Container sx={{ pb: { xs: 4, lg: 8 }, pt: 4 }}>
          <Grid
            container
            item
            flexDirection="column"
            alignItems="center"
            xs={12}
            md={8}
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography variant="h3" color="white" mb={2}>
              Estrutura MBA
            </MKTypography>
            <MKTypography variant="body2" color="white">
              Conteúdo do nosso MBA em Cyber, dividido por ano.
            </MKTypography>
          </Grid>
        </Container>
        <MKBox mt={-8}>
        <Container>
          <Grid container sx={{ mb: 4 }}>
            <Grid item xs={12} md={6} lg={4} sx={{ mx: "auto", textAlign: "center" }}>
              <AppBar position="static">
                <Tabs value={activeTab} onChange={handleTabType}>
                  <Tab
                    id="1ano"
                    label={
                      <MKBox py={0.5} px={2} color="inherit">
                        1º e 2º semestres
                      </MKBox>
                    }
                  />
                  <Tab
                    id="2ano"
                    label={
                      <MKBox py={0.5} px={2} color="inherit">
                        3º e 4º semestres
                      </MKBox>
                    }
                  />
                </Tabs>
              </AppBar>
            </Grid>
          </Grid>
        </Container>
        </MKBox>
      </MKBox>

        {/* === FAQ Section === */}
        <MKBox component="section" py={6} mt={{ xs: -6, md: -8 }} zIndex={1} position="relative">
        <Container>
            <Grid container justifyContent="center">
            <Grid item xs={12} md={10}>
                <Card>
                <MKBox py={2} px={3}>
                    {activeTab === 0 ? (
                    <>
                        <FaqCollapse
                        title="Capacitação econômica e financeira para negócios"
                        open={collapse === 1}
                        onClick={() => setCollapse(collapse === 1 ? false : 1)}
                        >
                        Este módulo oferece uma estrutura conceitual de finanças para que você compreenda o raciocínio teórico subjacente 
                        aos relatórios financeiros e à tomada de decisões econômicas na prática. O objetivo é fornecer um grau de 
                        alfabetização econômica e financeira suficiente para que você interprete e faça uso de informações financeiras 
                        publicadas e geradas internamente e entenda o processo de tomada de decisão que envolve informações financeiras.
                        <br /><br />
                        No nível mais fundamental, os gerentes devem possuir um alto nível de competência no uso de informações financeiras, 
                        sejam elas geradas para consumo interno, como informações de custo ou orçamento, ou informações financeiras e 
                        econômicas publicadas de fornecedores, clientes, concorrentes ou da própria organização do gerente. Este curso visa 
                        tratar dos principais tópicos e questões de finanças e economia que preocupam o gerente geral e todos aqueles que 
                        precisam tomar decisões, especialmente aquelas que podem tornar a organização vulnerável a riscos cibernéticos.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Tecnologias essenciais de segurança cibernética"
                        open={collapse === 2}
                        onClick={() => setCollapse(collapse === 2 ? false : 2)}
                        >
                        Este módulo busca fornecer a base tecnológica essencial necessária para que os gerentes e líderes tenham conversas
                        proativas com a equipe técnica para atingir os objetivos comerciais gerais. Embora este módulo tenha um foco em 
                        tecnologia, ele não pressupõe nenhum histórico tecnológico e oferece um caminho facilmente acessível para os aspectos 
                        tecnológicos da segurança cibernética. O módulo o conduzirá por todos os principais elementos fundamentais e os 
                        complementará com elementos da pesquisa atual para que você tenha uma amplitude de conhecimentos tecnológicos prontos 
                        para enfrentar os desafios do gerenciamento e da liderança em segurança cibernética.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Desafio de gerenciamento de segurança cibernética"
                        open={collapse === 1}
                        onClick={() => setCollapse(collapse === 1 ? false : 1)}
                        >
                        Você participará de dois desafios práticos, extraídos de situações do mundo real, que exigem a síntese da base de 
                        conhecimento disciplinar adquirida nos módulos anteriores. Não haverá um componente didático específico para esse 
                        módulo; o foco está na integração do conhecimento e das habilidades adquiridas no elemento didático do programa.
                        <br /><br />
                        Você trabalhará em grupos com cada membro do grupo alocado em uma função dentro da organização. Para cada desafio, 
                        as equipes receberão um cenário de segurança cibernética para gerenciar coletivamente. Elas terão que tomar decisões 
                        para a segurança de sua própria organização e, ao mesmo tempo, gerenciar as metas e os objetivos gerais da organização. 
                        Os principais métodos e modelos já foram apresentados nos módulos anteriores. Você precisará aplicar os modelos por 
                        meio de uma prática multidisciplinar e integradora. Você participará de desafios em momentos adequados ao longo do 
                        primeiro ano do programa para consolidar seu aprendizado.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Operações de segurança cibernética e resposta a incidentes"
                        open={collapse === 2}
                        onClick={() => setCollapse(collapse === 2 ? false : 2)}
                        >
                        O SOIM (Security Operations and Incident Management, gerenciamento de operações de segurança e incidentes) tornou-se um 
                        processo maduro, implantado em muitos ambientes, desde os primeiros a adotar setores de uso intensivo de TIC, como 
                        telecomunicações e bancos, e agora está penetrando em todos os setores, à medida que eles se tornam cada vez mais 
                        dependentes da tecnologia digital. O SOIM pode ser considerado como a capacidade das organizações de responder a incidentes, 
                        aprender com eles e se adaptar a eles. Este módulo aborda os fundamentos do SOIM e as formas como ele pode ser incorporado 
                        às estruturas, aos processos e à cultura organizacionais. Abrangerá a tecnologia, os processos e as arquiteturas essenciais, 
                        concentrando-se nas abordagens de monitoramento e detecção de incidentes.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Gestão e Governança de Riscos de Segurança Cibernética"
                        open={collapse === 1}
                        onClick={() => setCollapse(collapse === 1 ? false : 1)}
                        >
                        O módulo fornecerá uma base sólida nos princípios fundamentais da avaliação, gestão e governança de riscos cibernéticos, 
                        ao mesmo tempo em que expandirá esses domínios para abranger o conhecimento necessário para obter uma compreensão prática 
                        do tópico e de suas subáreas. Você aprenderá sobre a relação entre o risco e o ambiente de negócios digital e interconectado 
                        de hoje e explorará por que a avaliação e o gerenciamento eficazes de riscos são necessários para apoiar a comunicação de 
                        conceitos e valores de risco nas organizações.
                        <br /><br />
                        O módulo descreve diferentes perspectivas sobre a avaliação de riscos cibernéticos - de ativos individuais a metas e objetivos 
                        de todo o sistema - e abrange métodos comuns de avaliação de riscos e destaca seus usos e limitações. O módulo abordará os 
                        recursos de uma boa medição de risco (e métricas), como medir o risco, por que medir o risco e como esses conceitos afetam a 
                        avaliação e o gerenciamento de riscos.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Gestão Global de Operações e Marketing no Contexto Cibernético"
                        open={collapse === 2}
                        onClick={() => setCollapse(collapse === 2 ? false : 2)}
                        >
                        O principal objetivo educacional do módulo é aprimorar sua compreensão da gestão de operações e marketing e sua contribuição 
                        conjunta para o sucesso de uma organização. Discute-se a função integradora fundamental das operações como a conexão entre a 
                        estratégia e a entrega de um produto ou serviço a um cliente. São exploradas questões de design, planejamento e controle de 
                        processos e gerenciamento de capacidade, bem como a influência da natureza de uma tarefa, da disponibilidade de recursos e 
                        do gerenciamento de processos e qualidade sobre a eficácia das funções operacionais e de marketing. Além disso, são analisados 
                        o aprimoramento do desempenho e a experiência do cliente como aspectos críticos da organização. As ferramentas e os conceitos 
                        abordados neste curso serão aplicados a contextos e problemas específicos de segurança cibernética.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Liderança Inclusiva para Pessoas e Organizações"
                        open={collapse === 1}
                        onClick={() => setCollapse(collapse === 1 ? false : 1)}
                        >
                        O principal objetivo educacional deste módulo é fornecer uma compreensão crítica e prática das complexidades envolvidas na 
                        liderança em um contexto de segurança cibernética. Para isso, você aprenderá como as pessoas aprendem a liderar e desenvolverá 
                        uma compreensão do que é necessário para liderar de forma responsável e inclusiva, levando em consideração fatores econômicos, 
                        sociais e ambientais. Você obterá conhecimento e compreensão de questões importantes, como aprendizagem de liderança, liderança 
                        de mudanças e liderança ética, espiritual, servil e autêntica.
                        <br /><br />
                        Você desenvolverá as principais habilidades que lhe permitirão entender seu propósito como líder, definir uma visão a partir 
                        desse propósito e desenvolver o caráter que considera necessário para liderar de forma inclusiva. Especificamente, você explorará 
                        os desafios exclusivos de liderar em contextos incertos e altamente mutáveis no que se refere à segurança cibernética e à 
                        alfabetização. O conhecimento da natureza mutável do gerenciamento e da liderança nesse contexto é vital para o sucesso 
                        organizacional sustentável.
                        </FaqCollapse>
                    </>
                    ) : (
                    <>
                        <FaqCollapse
                        title="Dissertação de Pesquisa Aplicada"
                        open={collapse === 3}
                        onClick={() => setCollapse(collapse === 3 ? false : 3)}
                        >
                        Este módulo representa o elemento final do programa do MBA Executivo em Segurança Cibernética. Ele funciona como um módulo de 
                        conclusão, pedindo aos alunos que reflitam sobre a sua experiência e o conhecimento adquirido com o CEMBA em um projeto de 
                        pesquisa do mundo real, inspirado na indústria. A dissertação serve como um catalisador para uma especialização mais aprofundada 
                        em um determinado conceito organizacional e cibernético, bem como uma oportunidade de refinar e solidificar sua alfabetização 
                        e liderança em segurança organizacional e cibernética. Os alunos basearão seus projetos na empresa em que estão empregados 
                        atualmente. No entanto, se essa situação não for viável ou apropriada, será selecionada uma empresa de caso em conjunto com 
                        uma empresa patrocinadora para garantir a adoção significativa do resultado em um ambiente prático.
                        <br /><br />
                        Além da dissertação, você escreverá um artigo de reflexão sobre o projeto de pesquisa e outros aspectos do curso e como eles 
                        foram aplicados na sua prática atual.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Desafio de segurança cibernética"
                        open={collapse === 4}
                        onClick={() => setCollapse(collapse === 4 ? false : 4)}
                        >
                        Você participará de um desafio prático substancial durante 4 dias. O desafio simulará uma situação do mundo real. Essa situação 
                        exigirá que você sintetize a base de conhecimento disciplinar dos módulos ensinados e, em seguida, responda e resolva o desafio de segurança.
                        <br /><br />
                        Como este módulo se concentra na integração do conhecimento e das habilidades adquiridas no elemento ensinado do programa, não haverá 
                        um componente ensinado específico. Você trabalhará, sob orientação, de acordo com as abordagens profissionais atuais. A sua equipe 
                        receberá um cenário de segurança cibernética para gerenciar coletivamente e terá de tomar decisões para a segurança da sua própria 
                        organização e, ao mesmo tempo, gerenciar as metas e os objetivos gerais da organização.
                        <br /><br />
                        Os principais métodos e modelos de que você precisará para fazer isso já foram apresentados nos módulos anteriores. Você precisará 
                        aplicar os modelos por meio de uma prática multidisciplinar e integradora. O desafio deste módulo é o elemento integrativo fundamental do 
                        programa. Ele oferece o ponto intermediário significativo, antes de avançar para o trabalho substancial na sua dissertação, para refletir 
                        sobre o que você aprendeu no programa e como isso se aplica às suas atividades profissionais atuais.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Regulamentação da segurança cibernética"
                        open={collapse === 3}
                        onClick={() => setCollapse(collapse === 3 ? false : 3)}
                        >
                        O objetivo deste módulo é fornecer uma visão geral dos tópicos legais e regulamentares que merecem ser considerados ao realizar várias 
                        atividades de liderança e gerenciamento no campo da segurança cibernética, tais como: gerenciamento de segurança, avaliação de riscos, 
                        testes de segurança, investigação forense, pesquisa, desenvolvimento de produtos e serviços e operação cibernética.
                        <br /><br />
                        A intenção é fornecer uma base sólida para um gerente ou líder de segurança cibernética em relação aos conceitos regulatórios e legislativos 
                        comuns que se aplicam às suas atividades, destacando as fontes de autoridade jurídica e os estudos acadêmicos.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Fatores humanos na segurança cibernética"
                        open={collapse === 4}
                        onClick={() => setCollapse(collapse === 4 ? false : 4)}
                        >
                        O objetivo deste módulo é fornecer uma compreensão básica da função dos fatores humanos na segurança cibernética. Um aspecto fundamental 
                        é como projetar uma segurança que seja utilizável e aceitável para uma série de agentes humanos, por exemplo, usuários finais, administradores 
                        e desenvolvedores. Este módulo apresenta uma perspectiva organizacional e social mais ampla sobre a segurança que surgiu na última década: 
                        a importância da confiança e da colaboração para uma segurança cibernética eficaz, que só pode ser alcançada com o envolvimento das partes 
                        interessadas e a negociação de soluções de segurança que atendam às suas necessidades. Isso requer um conjunto de habilidades que, 
                        tradicionalmente, não faz parte do treinamento oferecido a especialistas e profissionais de segurança.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Inovação Responsável e Digitalização para Negócios"
                        open={collapse === 3}
                        onClick={() => setCollapse(collapse === 3 ? false : 3)}
                        >
                        Este módulo adota uma visão sistêmica da inovação nas organizações e a conceitua como uma prática e um processo incorporado no funcionamento 
                        das organizações e no trabalho de rotina dos funcionários. Isso significa que o módulo se afasta de visões mais funcionais e prescritivas da 
                        inovação que se concentram em produtos ou características individuais. Ele se concentra em entender o que é Inovação Digital e como ela pode 
                        ser estimulada e gerenciada nas organizações em um contexto de esforços potencialmente conflitantes em relação à segurança cibernética. 
                        Os alunos exploram o papel da tecnologia e da mídia digital como impulsionadores, mas também como elementos essenciais da inovação nas 
                        organizações, e como a tecnologia apoia o gerenciamento dessas demandas complexas e concorrentes, com foco especial na exploração da importância 
                        e dos elementos essenciais que contribuem para criar e estimular a inovação nas organizações.
                        <br /><br />
                        O módulo também aborda a implementação e o gerenciamento da inovação na prática, capturando os esforços para alinhar processos, cultura e 
                        lógicas internas com a inovação e a importância de gerenciar as demandas concorrentes em relação à segurança e enfatizar as lógicas de 
                        funcionamento baseadas na eficiência e no desempenho dos negócios.
                        </FaqCollapse>
                        <FaqCollapse
                        title="Gestão Estratégica"
                        open={collapse === 4}
                        onClick={() => setCollapse(collapse === 4 ? false : 4)}
                        >
                        Este módulo lhe dá a oportunidade de desenvolver uma compreensão da estratégia organizacional a partir de uma perspectiva científica, artística e 
                        baseada na prática.
                        <br />
                        A abordagem científica inclui um foco nos elementos analíticos da estratégia organizacional, que se concentra na “caixa de ferramentas” tradicional 
                        usada para desenvolver a estratégia de negócios.
                        <br />
                        A perspectiva artística incentiva você a se envolver na prática e na reflexão da criação de estratégias, acrescentando um elemento crítico ao seu 
                        conhecimento e à utilização da estratégia organizacional e da tomada de decisões.
                        <br />
                        Uma abordagem da estratégia baseada na prática ajuda você a considerar a relação entre a boa teoria e a boa prática dentro da gestão estratégica 
                        eficaz.
                        </FaqCollapse>
                    </>
                    )}
                </MKBox>
                </Card>
            </Grid>
            </Grid>
        </Container>
        </MKBox>
    </MKBox>
  );
}


export default MBAStructure;